import React from "react";

const Footer = () => {
  return (
    <footer style={{
      background:"#222",
      color:"white",
      textAlign:"center",
      padding:"15px"
    }}>
      <p>© 2026 Dr Abhinav Singh | Urology Clinic</p>
    </footer>
  );
};

export default Footer;